<template>
    <LoginHeader>

        <p class="text-center mb-10 text-2xl font-bold">Login To NetBanking</p>
        <div class="login-form">

            <div class="left-side text-left">

                <form @submit.prevent="otpSent ? validateOtp() : login()">
                    <div class="form-group">
                        <label for="username">Username:</label>
                        <input type="text" id="username" v-model="username" placeholder="Enter username" required />
                    </div>
                    <div class="form-group">
                        <label for="password">Password:</label>
                        <input type="password" id="password" v-model="password" placeholder="Enter password" required />
                    </div>
                    <div class="form-group" v-if="otpSent">
                        <label for="password">OTP:</label>
                        <OtpInput :otpLength="6" @updateOtp="otp = $event" />
                        <p class="text-right mt-4 text-sm text-blue-600 cursor-pointer hover:underline"
                            @click="resendOtp"
                            :class="{ 'opacity-50 cursor-not-allowed': loadingButton === 'resendOtp' }">
                            <span v-if="loadingButton === 'resendOtp'">Resending...</span>
                            <span v-else>Resend OTP</span>
                        </p>
                    </div>
                    <div class="form-group">
                        <div id="recaptcha-container"></div>
                    </div>
                    <p v-if="errorMessages" class="text-red-500 mt-2">{{ errorMessages }}</p>
                    <p v-if="successMessage" class="text-green-500 mt-2">{{ successMessage }}</p>
                    <button type="submit" class="bg-primary rounded mt-4"
                        :disabled="loadingButton === 'login' || loadingButton === 'validateOtp'">
                        <span v-if="loadingButton === 'login'">Logging in...</span>
                        <span v-else-if="loadingButton === 'validateOtp'">Validating...</span>
                        <span v-else>{{ otpSent ? 'Validate OTP' : 'Login' }}</span>
                    </button>
                    <router-link to="/forgotPassword"
                        class="text-center mt-4 text-sm text-blue-600 cursor-pointer hover:underline">
                        Forgot Password?
                    </router-link>
                </form>
                <!-- <div class="mt-3">
                    <div v-if="unid_src">
                        <iframe scrolling="no" frameborder="0" allowtransparency="true" :src="unid_src"
                            style="width:500px;height:48px;padding:0px 0px 0px 20px;"></iframe>
                    </div>
                    <div v-else class="text-sm text-gray-500 mt-2">
                        UNiD login currently unavailable.
                    </div>
                </div> -->

            </div>


            <div class="divider"></div>

            <div class="right-side">
                <div>
                    <div class="text-2xl text-center text-gray-400"><span>First Time User?</span></div>
                    <p class="mx-5 mt-2">
                        <router-link to="/register" class="text-blue-500 hover:text-blue-700">Register Now</router-link>
                        for a
                        host of convenient features.
                    </p>
                </div>
                <div class="mt-10 mx-5 text-left">
                    <div class="font-bold"><span>We have added a host of new features!</span></div>
                    <p class="text-base">You can now do so much more:</p>
                    <ul class="list-disc pl-5 text-base ml-0 text-sm">
                        <li>Anywhere access through Desktop of Mobile</li>
                        <li>Enchanced security measures</li>
                    </ul>
                </div>

                <!-- <p><router-link to="/register">Don't have an account? Register here</router-link></p> -->
            </div>
        </div>
    </LoginHeader>
</template>

<script>

import LoginHeader from "@/components/LoginHeader.vue";
import OtpInput from "@/components/OtpInput.vue";
import axios from "axios";

/* global grecaptcha */

export default {
    name: 'UserLogin',
    components: {
        LoginHeader, OtpInput
    },
    data() {
        return {
            username: '',
            password: '',
            errorMessages: '',
            successMessage: '',
            otp: '',
            otpSent: false,
            mobile: '',
            acno: '',
            loadingButton: null,
            recaptchaWidgetId: null,
            recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
            // unid_src: ''
        };
    },
    watch: {
        otpSent(newVal) {
            if (newVal) {
                this.renderRecaptcha();
            }
        }
    },
    // mounted() {
    //     if (sessionStorage.getItem("redirect_after_unid_login") === "true") {
    //         sessionStorage.removeItem("redirect_after_unid_login");
    //         console.log("🔁 Reload detected. Redirecting to dashboard.");
    //         this.$router.push("/dashboard");
    //         return;
    //     }

    //     // Load unID iframe
    //     axios.get("https://api-netbanking.dmcbank.co.in/unid/login-token")
    //         .then((res) => {
    //             this.unid_src = res.data.unid_src;
    //             console.log("📥 Loaded UNiD iframe src:", this.unid_src);

    //             if (!document.querySelector('script[src="//auth2.unid.net/js/callback.js"]')) {
    //                 const script = document.createElement("script");
    //                 script.src = "//auth2.unid.net/js/callback.js";
    //                 script.async = true;
    //                 document.body.appendChild(script);
    //                 console.log("📦 UNiD callback script injected.");
    //             }
    //         })
    //         .catch((err) => {
    //             console.error("❌ Failed to load UNiD iframe:", err);
    //             this.unid_src = "";
    //         });

    //     // Handle message from unID iframe
    //     window.addEventListener("message", async (event) => {
    //         if (
    //             event.origin.includes("auth2.unid.net") &&
    //             event.data?.status === true &&
    //             event.data?.access_token
    //         ) {
    //             try {
    //                 console.log("🔑 Access token received from UNiD, calling backend...");

    //                 const res = await fetch("https://api-netbanking.dmcbank.co.in/unid/login-callback?response_type=json", {
    //                     method: "POST",
    //                     headers: { "Content-Type": "application/x-www-form-urlencoded" },
    //                     body: new URLSearchParams({
    //                         status: "true",
    //                         access_token: event.data.access_token
    //                     }),
    //                     redirect: "manual"
    //                 });

    //                 if (res.status === 200) {
    //                     const data = await res.json();
    //                     if (data.status === "success") {
    //                         console.log("✅ RouteCode login successful:", data);

    //                         const userData = {
    //                             name: data.name,
    //                             acno: data.id,
    //                             dob: data.dob,
    //                             mobile: data.mobile,
    //                             unid_src: this.unid_src || ''
    //                         };

    //                         localStorage.setItem("token", data.token);
    //                         localStorage.setItem("user", JSON.stringify(userData));
    //                         localStorage.setItem("login_method", "routecode");

    //                         console.log("➡️ Redirecting to dashboard...");
    //                         this.$router.push("/dashboard");
    //                     } else {
    //                         console.error("❌ Login failed via RouteCode:", data.message);
    //                         this.errorMessages = data.message || "Login failed";
    //                     }
    //                 } else {
    //                     console.warn("⚠️ Unexpected redirect or error status:", res.status);
    //                     this.errorMessages = "Login failed. Unexpected redirect.";
    //                 }
    //             } catch (err) {
    //                 console.error("❌ Error during RouteCode login:", err);
    //                 this.errorMessages = "Login error: " + err.message;
    //             }
    //         }
    //     });
    // },
    methods: {
        renderRecaptcha() {
            const check = () => {
                if (window.grecaptcha && this.recaptchaSiteKey) {
                    this.recaptchaWidgetId = window.grecaptcha.render("recaptcha-container", {
                        sitekey: this.recaptchaSiteKey,
                    });
                } else {
                    setTimeout(check, 300);
                }
            };
            check();
        },

        async login() {
            if (this.loadingButton) return;
            this.loadingButton = 'login';

            this.errorMessages = '';

            if (!this.username || !this.password) {
                this.showError('Username and Password are required');
                this.loadingButton = null;
                return;
            }

            try {
                const response = await axios.post('https://api-netbanking.dmcbank.co.in/login', {
                    username: this.username,
                    password: this.password
                });

                if (response.data.status === 'success') {
                    this.loadingButton = false;
                    this.mobile = response.data.mobile;
                    this.acno = response.data.customerId;
                    this.otpSent = true;
                } else {
                    this.showError(response.data.message || 'Failed to send OTP');
                }

            } catch (error) {
                const errorMessage = error.response && error.response.data && error.response.data.status === 'failure'
                    ? error.response.data.message
                    : 'Error sending OTP: ' + error.message;
                this.showError(errorMessage);
            } finally {
                this.loadingButton = null;
            }
        },
        async resendOtp() {
            if (this.loadingButton) return;
            this.loadingButton = 'resendOtp';

            try {
                const response = await axios.post('https://api-netbanking.dmcbank.co.in/resend-otp', {
                    username: this.username,
                    context: 'login'
                });

                if (response.data.status === 'success') {
                    this.successMessage = 'OTP resent successfully';
                    setTimeout(() => { this.successMessage = ''; }, 3000);
                } else {
                    this.showError(response.data.message || 'Failed to resend OTP');
                }
            } catch (error) {
                this.showError(error.response?.data?.message || 'Error resending OTP');
            } finally {
                this.loadingButton = null;
            }
        },
        async validateOtp() {
            if (this.loadingButton) return;
            this.loadingButton = 'validateOtp';

            const recaptchaResponse = grecaptcha.getResponse(this.recaptchaWidgetId);

            if (!recaptchaResponse) {
                this.showError("Please complete the CAPTCHA");
                return;
            }

            this.errorMessages = '';
            // const otp = this.otpArray.join('');

            if (this.otp.length !== 6) {
                this.showError('Enter a valid 6-digit OTP');
                this.loadingButton = null;
                return;
            }

            try {
                const response = await axios.post('https://api-netbanking.dmcbank.co.in/verify_otp', {
                    mobile: this.mobile,
                    acno: this.acno,
                    otp: this.otp,
                    recaptchaToken: recaptchaResponse
                });

                if (response.data.status === 'success') {
                    this.loadingButton = false;
                    localStorage.setItem('token', response.data.token);
                    localStorage.setItem('user', JSON.stringify({
                        name: response.data.name,
                        acno: this.acno,
                        dob: response.data.dob,
                        mobile: this.mobile,
                        // unid_src: response.data.unid_src
                    }))
                    this.$router.push('/dashboard');
                } else {
                    this.showError(response.data.message || 'Failed to send OTP');
                }

            } catch (error) {
                const errorMessage = error.response && error.response.data && error.response.data.status === 'failure'
                    ? error.response.data.message
                    : 'Error sending OTP: ' + error.message;
                this.showError(errorMessage);
            } finally {
                this.loadingButton = null;
            }
        },
        showError(message) {
            this.errorMessages = message;
            if (this.errorTimeout) {
                clearTimeout(this.errorTimeout);
            }
            this.errorTimeout = setTimeout(() => {
                this.errorMessages = '';
            }, 3000);
        },
    }
};
</script>

<style scoped>
.login-form {
    display: flex;
    justify-content: space-between;
}

.left-side,
.right-side {
    width: 48%;
}

.left-side h2 {
    margin-bottom: 20px;
}

.form-group {
    margin-bottom: 15px;
}

.form-group label {
    display: block;
}

.form-group input {
    width: 100%;
    padding: 8px;
    margin-top: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

button {
    width: 100%;
    padding: 10px;
    /* background-color: #4CAF50; */
    color: white;
    border: none;
    cursor: pointer;
}

/* button:hover {
    background-color: #45a049;
  } */

.divider {
    width: 1px;
    background-color: #ddd;
    margin: 0 20px;
}

.right-side p {
    font-size: 14px;
}

.right-side a {
    color: #007BFF;
}

.right-side a:hover {
    text-decoration: underline;
}
</style>
